import { render, staticRenderFns } from "./AiScoreLogViewModal.vue?vue&type=template&id=2627b05e"
import script from "./AiScoreLogViewModal.vue?vue&type=script&lang=js"
export * from "./AiScoreLogViewModal.vue?vue&type=script&lang=js"
import style0 from "./AiScoreLogViewModal.vue?vue&type=style&index=0&id=2627b05e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports